import {BasicBatchWrapper} from './BasicBatchWrapper';

export class UploadWrapper extends BasicBatchWrapper {
file: string;
fileFormat: string;
fileName: string;
}

